__turbopack_context__.v({
  "blurred": "tranchePanel-module-scss-module__Yy9pIa__blurred",
  "dropped": "tranchePanel-module-scss-module__Yy9pIa__dropped",
  "tranchePanel": "tranchePanel-module-scss-module__Yy9pIa__tranchePanel",
});
